import { FuseNavigation } from '@fuse/types';
import { Title } from '@angular/platform-browser';

export const navigation: FuseNavigation[] = [
    {
        id       : 'categorias',
        title    : 'Categorias',
        translate: 'NAV.CATEGORIAS',
        type     : 'group',
        children : [
            {
                id       : 'home',
                title    : 'Home',
                translate: 'NAV.HOME',
                type     : 'item',
                icon     : 'home',
                url      : '../',
                exactMatch: true
            }
        ]
    }
];
